"use client";

import { SessionProvider } from "next-auth/react";
import type { Session } from "next-auth";

interface AuthSessionProviderProps {
  children: React.ReactNode;
  session: Session | null;
}

export function AuthSessionProvider({ children, session }: AuthSessionProviderProps) {
  // Pasamos la `session` inicial desde el root layout server para que
  // `useSession()` no tenga que fetchear /api/auth/session en el primer render.
  // Sin esto, los componentes que dependen de la session (Sidebar, AppShell)
  // ven `status: "loading"` justo después de loguearse y la pantalla queda
  // en blanco hasta que llega el fetch.
  return <SessionProvider session={session}>{children}</SessionProvider>;
}
